import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { subscriptionActions } from '../../../redux/slices/subscriptionSlice';
import { CheckoutSession } from '../../../redux/slices/subscriptionSlice';
import { useAppDisPatch, useAppSelector } from '../../../redux/store';
import useHttps from '../../useHttps';

const useInitializePayment = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const { authData } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  const onSuccess = useCallback((response: unknown) => {
    const data = (response as SuccessHttpResponse<CheckoutSession>).data;
    dispatch(subscriptionActions.setCheckoutSession(data));
  }, [dispatch]);

  const onError = useCallback((err: AxiosError<ErrorHttpResponse>) => {
    console.error('Error initializing payment:', err?.message);
    dispatch(subscriptionActions.setError(err?.response?.data?.message ?? 'Failed to initialize payment'));
  }, [dispatch]);

  const initializePayment = useCallback((planId: string) => {
    const subscriberType = authData?.companyId ? 'COMPANY' : 'LOCUM';
    const url: HttpConfig = {
      url: 'auth-service/payments/initialize',
      method: 'post',
      data: {
        planId,
        subscriberType,
      },
    };
    return request(url, onSuccess, setLoading, onError);
  }, [authData?.companyId, onError, onSuccess, request]);

  return { initializePayment, loading };
};

export default useInitializePayment;
